import classNames from 'classnames';
import * as React from 'react';

import styles from './CustomIndicator.module.scss';

export interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
  clickHandler?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const CustomIndicator: React.FunctionComponent<Props> = ({
  className,
  isActive,
  clickHandler,
  ...props
}) => (
  <button
    type="button"
    className={classNames(styles.indicator, className, { active: isActive })}
    {...props}
    onClick={clickHandler}
  />
);

export default CustomIndicator;
